import React, { useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
//import events from "./events";
import "react-big-calendar/lib/css/react-big-calendar.css";

require('moment/locale/es.js')
const localizer = momentLocalizer(moment);

export default function ReactBigCalendar(citas) {

  console.log('objcal');
  console.log(citas.citas);
  //console.log(this.props);
  const [eventsData, setEventsData] = useState(citas.citas);

  const handleSelect = ({ start, end }) => {
    console.log(start);
    console.log(end);
    const title = window.prompt("New Event name");
    if (title)
      setEventsData([
        ...eventsData,
        {
          start,
          end,
          title
        }
      ]);
  };
  return (
    <div className="App">
      <Calendar
        views={["day", "agenda", "month"]}
        selectable
        localizer={localizer}
        defaultDate={new Date()}
        defaultView="month"
        events={citas.citas}
        style={{ height: "70vh" }}
      //  onSelectEvent={(event) => alert(event.title)}
       // onSelectSlot={handleSelect}

       messages={{
        next: "Sig",
        previous: "Ant",
        today: "Hoy",
        month: "Mes",
        week: "Semana",
        day: "Día"
      }}
      />
    </div>
  );
}
